import { render, staticRenderFns } from "./UpdateThongTinDDAT.vue?vue&type=template&id=399e60a2"
import script from "./UpdateThongTinDDAT.vue?vue&type=script&lang=js"
export * from "./UpdateThongTinDDAT.vue?vue&type=script&lang=js"
import style0 from "./UpdateThongTinDDAT.vue?vue&type=style&index=0&id=399e60a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports